document.addEventListener('DOMContentLoaded', function () {
  // Defining Shopify.formatMoney function
  Shopify.formatMoney = function(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '{{amount}}';

      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = precision || 2;
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number == null) return 0;

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.');
          var dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              '$1' + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }

      return value;
  };

  // Initialize variables for drawer and buttons
  var customCartDrawer = document.getElementById('custom-drawer-cart');
  var cartButton = document.getElementById('custom-cart-button');
  var closeButton = document.getElementById('custom-drawer-cart-close');
  var continueShoppingButton = document.getElementById('continue-shopping');
  var goToCheckoutButton = document.getElementById('go-to-checkout');

  // Function to open the cart drawer
  function openCartDrawer() {
      if (customCartDrawer) {
          customCartDrawer.style.right = '0';
          customCartDrawer.style.display = 'block';
      }
  }

  // Function to close the cart drawer
  function closeCartDrawer() {
      if (customCartDrawer) {
          customCartDrawer.style.right = '-320px';
          setTimeout(function () {
              customCartDrawer.style.display = 'none';
          }, 300);
      }
  }

  // Attach event listeners to buttons
  if (cartButton) {
      cartButton.addEventListener('click', function() {
          openCartDrawer(); // Open the cart when the button is clicked
      });
  }

  if (closeButton) {
      closeButton.addEventListener('click', closeCartDrawer);
  }

  if (continueShoppingButton) {
      continueShoppingButton.addEventListener('click', closeCartDrawer);
  }

  if (goToCheckoutButton) {
      goToCheckoutButton.addEventListener('click', function () {
          window.location.href = '/checkout';
      });
  }

  // Function to update the cart drawer with latest cart contents
  function updateCartDrawer() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            var cartContent = '';

            cart.items.forEach((item, index) => {
                // Ensure item.price and compare_at_price are properly formatted
                var itemPriceFormatted = Shopify.formatMoney(item.price);
                var itemTotalFormatted = Shopify.formatMoney(item.price * item.quantity);
                
                // Initialize variable for the original price
                var originalPriceFormatted = '';

                // Check if the item is on sale
                if (item.compare_at_price && item.compare_at_price > item.price) {
                    originalPriceFormatted = Shopify.formatMoney(item.compare_at_price);
                }

                cartContent += `
                    <div class="custom-cart-item" data-item-id="${item.id}" data-line="${index + 1}">
                        <div class="custom-cart-item__image">
                            <img src="${item.image}" alt="${item.title}">
                        </div>
                        <div class="custom-cart-item__details">
                            <h6>${item.title}</h6>
                            <div class="custom-quantity-picker">
                                <button class="decrease">-</button>
                                <input type="number" min="1" value="${item.quantity}" class="quantity" data-line="${index + 1}">
                                <button class="increase">+</button>
                            </div>`;

                // Add the original price with strikethrough if the item is on sale
                if (originalPriceFormatted) {
                    cartContent += `
                            <h6 class="original-price" style="text-decoration: line-through; color: #999;">
                                Original: ${originalPriceFormatted}
                            </h6>`;
                }

                // Always add the total price
                cartContent += `
                            <h6 class="total-price">
                                Total: ${itemTotalFormatted}
                            </h6>
                            <button class="remove-item">Remove</button>
                        </div>
                    </div>`;
            });

            // Handle subtotal formatting
            if (typeof cart.total_price !== 'undefined' && !isNaN(cart.total_price)) {
                var subtotalFormatted = Shopify.formatMoney(cart.total_price);
                document.querySelector('.subtotal').textContent = 'Subtotal: ' + subtotalFormatted;
            } else {
                console.error('cart.total_price is undefined or not a number');
                document.querySelector('.subtotal').textContent = 'Subtotal: Not available';
            }

            // Update the cart drawer content
            document.querySelector('#custom-drawer-cart .custom-drawer-cart__content').innerHTML = cartContent;

            // Reattach event handlers for quantity changes and removal
            attachCartItemHandlers();
        })
        .catch(error => console.error('Error updating cart:', error));
}

  // Function to attach event handlers to the cart items
  function attachCartItemHandlers() {
      document.querySelectorAll('.custom-cart-item').forEach(function (item) {
          var decreaseButton = item.querySelector('.decrease');
          var increaseButton = item.querySelector('.increase');
          var quantityInput = item.querySelector('.quantity');
          var removeButton = item.querySelector('.remove-item');

          decreaseButton.addEventListener('click', function () {
              var newQuantity = Math.max(1, parseInt(quantityInput.value) - 1);
              updateCart(quantityInput.dataset.line, newQuantity, item);
          });

          increaseButton.addEventListener('click', function () {
              var newQuantity = parseInt(quantityInput.value) + 1;
              updateCart(quantityInput.dataset.line, newQuantity, item);
          });

          quantityInput.addEventListener('change', function () {
              var newQuantity = Math.max(1, parseInt(quantityInput.value));
              updateCart(quantityInput.dataset.line, newQuantity, item);
          });

          removeButton.addEventListener('click', function () {
              removeItem(quantityInput.dataset.line, item);
          });
      });
  }

  // Function to update the cart quantities
  function updateCart(line, quantity, item) {
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
          },
          body: JSON.stringify({ quantity: quantity, line: line }),
      })
      .then(response => response.json())
      .then(data => {
          updateCartDrawer();  // Update the drawer with the new contents
      })
      .catch(error => console.error('Error updating cart:', error));
  }

  // Function to remove an item from the cart
  function removeItem(line, item) {
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
          },
          body: JSON.stringify({ quantity: 0, line: line }),
      })
      .then(response => response.json())
      .then(data => {
          updateCartDrawer();  // Update the drawer after item is removed
      })
      .catch(error => console.error('Error removing item:', error));
  }

  // Handle add to cart forms to update the drawer and open it
  $(document).on('submit', 'form[action="/cart/add"]', function(e){
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('[type="submit"]');
      $addToCartBtn.text('Adding...').prop('disabled', true);

      // Add to cart via AJAX
      $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          success: function() {
              // Re-enable button and reset text
              $addToCartBtn.text('Add to cart').prop('disabled', false);

              // Update and open the cart drawer
              updateCartDrawer();  // Update the cart drawer
          },
          error: function(XMLHttpRequest) {
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              alert(response.message); // Show error message
              $addToCartBtn.prop('disabled', false).text('Add to cart');
          }
      });
  });

  // Initial attachment of event handlers for existing cart items
  attachCartItemHandlers(); // Ensure event listeners are attached on page load
});


document.addEventListener("DOMContentLoaded", function() {
    var announcementBar = document.getElementById("shopify-section-announcement-bar");
    var header = document.getElementById("shopify-section-header");

    if (announcementBar && header) {
        // Get the height of the announcement bar
        var announcementBarHeight = announcementBar.offsetHeight;

        // Apply the margin-top dynamically to the header based on announcement bar height
        header.style.top = announcementBarHeight - 1 + "px";
    }
});
